import AnalyticsPage from '../pages/dashboard/components/pages/AnalyticsPage';
import EmailAnalytics from '../pages/email/analytics/EmailAnalytics';
import { useChannelMode } from '../context/channelModeContext';
import '../pages/email/shared/emailDesign.css';

export default function AnalyticsRoute() {
  const { isEmail } = useChannelMode();
  return isEmail ? <EmailAnalytics /> : <AnalyticsPage />;
}
